interface WeatherSummaryFooterProps {
  maxSlots: number;
}

export function WeatherSummaryFooter({ maxSlots }: WeatherSummaryFooterProps) {
  return (
    <div className="flex-shrink-0 px-3 py-1.5 border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800">
      <p className="text-xs text-center text-gray-500 dark:text-gray-400">
        Showing {maxSlots} time slots (3-hour intervals). Adjust time horizon in the sidebar.
      </p>
    </div>
  );
}
